import React from "react";

function Header() {
  return (
    <div className="header">
      <h1>Where in the world?</h1>
    </div>
  );
}

export default Header;
